import React, { useState } from 'react';
import useSubdomain from '../../hooks/useSubdomain';
import { useTheme } from '../../hooks/useTheme';
import DataLoading from '../../components/dataLoading';
import { useTranslation } from 'react-i18next';
import { postCall } from '../../hooks/Network';
const ApiKey = process.env.REACT_APP_API_KEY;

// Forgot Password component

const ResetPass = () => {
  const [isSended, setIsSended] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [emailAddress, setEmailAddress] = useState('');
  const [otp, setOTP] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [successMsg, setSuccessMsg] = useState('');
  const [msg, setMsg] = useState('');

  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [passwordValidations, setPasswordValidations] = useState({
    minLength: false,
    maxLength: false,
    hasUppercase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  const { subdomain } = useSubdomain();
  const { theme, loading, error } = useTheme({ subdomain: subdomain });
  const { t } = useTranslation();

  if (loading) return <DataLoading title='Loading Theme' />;
  if (error) return `Error! ${error}`;

  function validateEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  const updatePasswordWithOTP = async (e) => {
    e.preventDefault();

    try {
      setSuccessMsg('');

      if (emailAddress == '') {
        setMsg(t('pleaseEnterTheEmail'));
        return false;
      }

      if (!validateEmail(emailAddress)) {
        setMsg(t('invalidEmail'));
        return false;
      }

      if (otp == '') {
        setMsg(t('pleaseEnterTheOtp'));
        return false;
      }

      if (passwordValidations.minLength === false) {
        setMsg(t('mustBeAtleast9Character'));
        return false;
      } else if (passwordValidations.maxLength === false) {
        setMsg(t('mustBeAtLessthan16Character'));
        return false;
      } else if (passwordValidations.hasUppercase === false) {
        setMsg(t('mustBeAtleastOneUppercase'));
        return false;
      } else if (passwordValidations.hasLowercase === false) {
        setMsg(t('mustBeAtleastOneLowercase'));
        return false;
      } else if (passwordValidations.hasNumber === false) {
        setMsg(t('mustBeAtleastOneNumber'));
        return false;
      } else if (passwordValidations.hasSpecialChar === false) {
        setMsg(t('mustIncludeAtleastOneSpecialCharacter'));
        return false;
      }

      if (confirmPassword == '') {
        setMsg(t('pleaseEnterConfirmPassword'));
        return false;
      }

      if (newPassword != confirmPassword) {
        setMsg(t('newPasswordAndConfirm'));
        return false;
      }

      setIsLoading(true);

      setMsg('');

      let res = await postCall({
        url: 'updatePasswordWithOTP',
        bodyData: { otpCode: otp, newPassword: newPassword, emailAddress: emailAddress },
        header: { 'API-key': ApiKey },
      });

      if (res.status === 200 && res.data && res.data?.success == true) {
        setIsSended(true);
        setSuccessMsg(t('passwordUpdatedSuccessfully'));
      } else if (res.status === 200 && res.data && res.data?.success == false) {
        setMsg(res.data?.message);
      } else {
        console.log('Error');
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const validatePassword = (password) => {
    setShowPasswordPopup(true);
    setPasswordValidations({
      minLength: password.length >= 9,
      maxLength: password.length > 0 && password.length < 16,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });

    setNewPassword(password);
  };

  const fnOTP = (e) => {
    if (e.target.value.length <= 6) {
      setOTP(e.target.value);
    }
  };

  if (theme?.favicon?.url) {
    const favicon = document.querySelector('link[rel="icon"]');

    if (favicon) {
      favicon.href = theme?.favicon?.url;
    } else {
      const newFavicon = document.createElement('link');
      newFavicon.rel = 'icon';
      newFavicon.href = theme?.favicon?.url;
      document.head.appendChild(newFavicon);
    }
  }

  return (
    <>
      {isLoading && <DataLoading title='Loading' />}

      {!isLoading && (
        <div
          className='page-wrapper page-center reset-pg'
          style={{ background: theme?.loginColor ?? '#f1f5f9', position: 'relative' }}
        >
          <div className='container container-tight py-4'>
            <form
              className='card card-md'
              action='./'
              method='get'
              autoComplete='off'
              noValidate=''
            >
              <div className='card-body'>
                <div className='text-center mb-4 d-print-none text-white'>
                  <img
                    src={theme?.loginLogo?.url ?? `/images/webOffice.png`}
                    alt='Eaconomy'
                    style={{ maxWidth: '300px', maxHeight: '65px' }}
                  />
                </div>
                <h2 className='h2 text-center mb-4'>{t('createPassword')}</h2>
                <p className='text-muted mb-4'>{t('enterYourEmailInstructions')}</p>
                <div
                  id='passwordSuccess'
                  className='alert alert-success d-none'
                  role='alert'
                >
                  {t('anEmailWithInstructions')}
                </div>

                <div className='mb-3'>
                  <label className='form-label'>{t('confirmEmail')}</label>
                  <input
                    type='email'
                    className='form-control'
                    placeholder='Enter email'
                    value={emailAddress}
                    onChange={(e) => setEmailAddress(e.target.value)}
                  />
                </div>

                <div className='mb-3'>
                  <label className='form-label'>{t('otp')}</label>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Enter OTP'
                    value={otp}
                    onChange={(e) => fnOTP(e)}
                  />
                </div>

                <div className='mb-3'>
                  <label className='form-label tt-cp'>{t('newPassword')}</label>
                  <input
                    type='password'
                    className='form-control'
                    placeholder='Enter New Password'
                    value={newPassword}
                    onChange={(e) => {
                      validatePassword(e.target.value);
                    }}
                    onBlur={() => setShowPasswordPopup(false)}
                  />
                </div>

                {showPasswordPopup && (
                  <div className='password-popup'>
                    <ul>
                      <li>
                        {passwordValidations.minLength ? '✔️' : '❌'}{' '}
                        {t('mustBeAtleast9Character')}
                      </li>
                      <li>
                        {passwordValidations.maxLength ? '✔️' : '❌'}{' '}
                        {t('mustBeAtLessthan16Character')}
                      </li>
                      <li>
                        {passwordValidations.hasUppercase ? '✔️' : '❌'}{' '}
                        {t('mustBeAtleastOneUppercase')}
                      </li>
                      <li>
                        {passwordValidations.hasLowercase ? '✔️' : '❌'}{' '}
                        {t('mustBeAtleastOneLowercase')}
                      </li>
                      <li>
                        {passwordValidations.hasNumber ? '✔️' : '❌'}{' '}
                        {t('mustBeAtleastOneNumber')}
                      </li>
                      <li>
                        {passwordValidations.hasSpecialChar ? '✔️' : '❌'}
                        {t('mustIncludeAtleastOneSpecialCharacter')}
                      </li>
                    </ul>
                  </div>
                )}

                <div className='mb-3'>
                  <label className='form-label'>{t('confirmPassword')}</label>
                  <input
                    type='password'
                    className='form-control'
                    placeholder='Enter Confirm Password'
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>

                {msg && <small className='text-danger text-start'>{msg}</small>}
                {successMsg && (
                  <small className='text-success text-start'>{successMsg}</small>
                )}

                <div className='form-footer'>
                  <button
                    href='#'
                    className={`btn btn-primary w-100 ${isSended === true ? 'disabled' : ''}`}
                    onClick={updatePasswordWithOTP}
                  >
                    {t('submit')}
                  </button>
                </div>
                <div className='text-center text-muted mt-3'>
                  {t('returnTo')} <a href='/'>{t('signIN')}</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

// Get Os function
const getOS = (userAgent) => {
  const { t } = useTranslation();

  const platformMatch = userAgent.match(/(Win|Mac|Linux)/i);
  if (platformMatch) {
    const platform = platformMatch[0].toLowerCase();
    if (platform === 'win') return t('windows');
    return platform;
  }
  return t('unknown');
};

// Get Browser Info Function
const getBrowserInfo = (userAgent) => {
  const { t } = useTranslation();

  if (userAgent.indexOf('Chrome') !== -1) return t('googleChrome');
  else if (userAgent.indexOf('Safari') !== -1) return t('safari');
  else if (userAgent.indexOf('Firefox') !== -1) return t('mozillaFirefox');
  else if (userAgent.indexOf('Edge') !== -1) return t('microsoftEdge');
  else if (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1)
    return t('internetExplorer');

  return t('unknown');
};

export default ResetPass;
